import { createSlice } from '@reduxjs/toolkit'

import { removeDowngradeAction } from './actions/remove_scheduled_downgrade'

const removeDowngradeSlice = createSlice({
  name: 'removeDowngrade',
  initialState: {
    step: null,
    billing_info: null,
    error: null,
    loading: false,
    removeModalVisible: false
  },
  reducers: {
    resetRemoveDowngradeData: (state) => {
      state.step = null
      state.billing_info = null
      state.error = null
      state.loading = false
      state.removeModalVisible = false
    },
    showRemoveDowngradeModal: (state) => {
      state.step = 'removeDowngrade/visible'
      state.billing_info = null
      state.error = null
      state.removeModalVisible = true
    }
  },
  extraReducers: (builder) => {
    builder.addCase('removeDowngrade/setStep', (state, { payload }) => {
      state.step = payload
    })
    builder.addCase(removeDowngradeAction.pending, (state) => {
      state.loading = true
    })
    builder.addCase(removeDowngradeAction.fulfilled, (state) => {
      state.loading = false
      state.error = null
      state.step = 'removeDowngradeSuccess'
    })
    builder.addCase(removeDowngradeAction.rejected, (state, { payload }) => {
      state.loading = false
      state.step = 'removeDowngradeFailure'
      state.error = payload
    })
  }
})

export const {
  reducer,
  actions: {
    resetRemoveDowngradeData,
    showRemoveDowngradeModal
  }
} = removeDowngradeSlice
